import { Recipient } from '@bonusly/recipient-entities';

type Content = {
	type: string;
	attrs?: Record<string, any>;
	text?: string;
	marks?: { type: string }[];
};

export const createRecipientContent = (recipient: Recipient) => {
	return [
		{ type: 'recipient', attrs: { id: recipient.username, record: recipient } },
		{ type: 'text', text: ' ' },
	] as Content[];
};

export const createAmountContent = (amount: number) => {
	return [
		{ type: 'amount', attrs: { id: amount.toString() } },
		{ type: 'text', text: ' ' },
	] as Content[];
};

export const createHashtagContent = (hashtag: string) => {
	return [
		{ type: 'text', text: ' ' },
		{ type: 'hashtag', attrs: { id: hashtag } },
	] as Content[];
};

/**
 * Build TipTap content from raw draft data (usernames, not full Recipient objects).
 * Used by Bizy draft cards where we have usernames but no Recipient records.
 */
export const createDraftContent = (recipients: string[], text?: string, amount?: number, hashtags?: string[], options?: { aiGenerated?: boolean }) => {
	const nodes: Content[] = [];
	const aiMark = options?.aiGenerated ? [{ type: 'suggestion-highlight' }] : undefined;

	recipients.forEach((username, i) => {
		if (i > 0) nodes.push({ type: 'text', text: ' ' });
		nodes.push({ type: 'recipient', attrs: { id: username } });
	});

	if (recipients.length > 0) nodes.push({ type: 'text', text: ' ' });

	if (amount !== undefined && amount > 0) {
		nodes.push(...createAmountContent(amount));
	}

	if (text) {
		nodes.push({ type: 'text', text, marks: aiMark });
	}

	if (hashtags && hashtags.length > 0) {
		hashtags.forEach((hashtag) => {
			nodes.push(...createHashtagContent(hashtag));
		});
	}

	return {
		type: 'doc',
		content: [{ type: 'paragraph', content: nodes }],
	};
};

export const createRecognitionContent = (recipient: Recipient, text?: string, amount?: number, hashtags?: string[], options?: { aiGenerated?: boolean }) => {
	const content = createRecipientContent(recipient);
	const aiMark = options?.aiGenerated ? [{ type: 'suggestion-highlight' }] : undefined;

	// Add amount if provided
	if (amount !== undefined && amount > 0) {
		content.push(...createAmountContent(amount));
	}

	// Add text if provided
	if (text) {
		content.push({
			type: 'text',
			text: text,
			marks: aiMark,
		});
	}

	// Add hashtags if provided
	if (hashtags && hashtags.length > 0) {
		hashtags.forEach((hashtag) => {
			content.push(...createHashtagContent(hashtag));
		});
	}

	return {
		type: 'doc',
		content: [
			{
				type: 'paragraph',
				content: content,
			},
		],
	};
};
